import Vue from 'vue';

export default Vue.filter('point', (value) => {
    return value ?
        parseFloat(value).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) :
        0;
});